"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Close = function Close(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M16.817 16.824a.625.625 0 01-.885 0l-3.937-3.938L8.06 16.82a.626.626 0 01-.885-.884l3.934-3.934-3.933-3.934a.625.625 0 01.885-.884l3.933 3.933 3.937-3.937a.625.625 0 11.884.885l-3.936 3.937 3.937 3.937a.625.625 0 010 .885z"
  }));
};

var _default = (0, _react.forwardRef)(Close);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Close, "Close", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Close.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Close.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9DbG9zZS50c3giXSwibmFtZXMiOlsiQ2xvc2UiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsS0FBcUUsR0FBRyxTQUF4RUEsS0FBd0UsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDNUU7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FENEU7QUFBQSxDQUE5RTs7ZUFTZSx1QkFBV0YsS0FBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxLIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBDbG9zZTogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTYuODE3IDE2LjgyNGEuNjI1LjYyNSAwIDAxLS44ODUgMGwtMy45MzctMy45MzhMOC4wNiAxNi44MmEuNjI2LjYyNiAwIDAxLS44ODUtLjg4NGwzLjkzNC0zLjkzNC0zLjkzMy0zLjkzNGEuNjI1LjYyNSAwIDAxLjg4NS0uODg0bDMuOTMzIDMuOTMzIDMuOTM3LTMuOTM3YS42MjUuNjI1IDAgMTEuODg0Ljg4NWwtMy45MzYgMy45MzcgMy45MzcgMy45MzdhLjYyNS42MjUgMCAwMTAgLjg4NXpcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihDbG9zZSk7XG4iXX0=